import React from "react";
import "./index.less";
import { openUrl } from "@/utils";
import { collectEvent } from "@/services/dataTrack";
import { useHistory } from "react-router";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";

interface NewFeaturesProps {}

const dataSource = [
    {
        title: "分销代发",
        content: (
            <>
                <div>一键推送订单 无需解密</div>
                <div>厂家发货先商家后台同步发货</div>
            </>
        ),
        img: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01F3CWCp2DwkNz4suVp_!!54458674.png",
        target: "https://qw15p3s8hv.feishu.cn/wiki/CezrwDG7AiZ76nk1TFdc5Q5JnWh",
    },
    {
        title: "拆分订单",
        content: (
            <>
                <div style={{ lineHeight: "8px" }}>&nbsp;</div>

                <div>多种商品 一键点击拆分</div>
            </>
        ),
        img: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01e8IbNZ2DwkNrUyHql_!!54458674.png",
        target: "https://qw15p3s8hv.feishu.cn/wiki/wikcnmWdnmLbjjPQOnC92ESMJcf",
    },
    {
        title: "拿货标签",
        content: (
            <>
                <div>有效解决配货混乱、商品漏拿、</div>
                <div>缺货数量登记不清、分拣繁琐等问题</div>
            </>
        ),
        img: "https://img.alicdn.com/imgextra/i1/54458674/O1CN01LApqgv2DwkTQTkR57_!!54458674.png",
        target: "https://qw15p3s8hv.feishu.cn/wiki/HU6DwDEXbiYcEtkDBpCcPm8Dnth",
    },
];

const NewFeatures: React.FC<NewFeaturesProps> = function (props) {
    const history = useHistory();

    return (
        <div className="ec-new-features">
            <div
                className="primary cursor-pointer"
                onClick={() => {
                    window.open(
                        "https://mp.weixin.qq.com/s?__biz=MzI3OTEyMjQ1Mg==&mid=2247486832&idx=1&sn=c2974ef3df6883a3244e3cb11400106d&chksm=ea527f42af644b357bf8c95d11a10bdbe0429660175eda234f7e7b05db621b114f403328270f&mpshare=1&scene=1&srcid=0228yaLwszllmW4GGDfzFc7G&sharer_shareinfo=c67ce98c2fa27187f63e571eab3f0663&sharer_shareinfo_first=c67ce98c2fa27187f63e571eab3f0663&version=4.1.10.70233&platform=mac&nwr_flag=1#wechat_redirect",
                        "blank",
                    );
                    history.push("/features/autoPrint");
                }}
            >
                <img
                    src="https://img.alicdn.com/imgextra/i2/54458674/O1CN01YelJTE2DwkVmRwAdA_!!54458674.jpg"
                    className="w"
                />
            </div>
            <div className="secondary">
                {dataSource.map(({ img, content, title, target }, index) => {
                    return (
                        <div
                            key={index}
                            className="point feature-item"
                            onClick={() => {
                                openUrl(target);

                                collectEvent(DataTrackEvent.CLICK_HOME_CONTENT, {
                                    content: title,
                                });
                            }}
                        >
                            <img src={img} alt="" />
                            <div className="title">{title}</div>
                            <div className="content">{content}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default React.memo(NewFeatures);
